(function () {
  document.querySelectorAll('.svd-video-gallery').forEach(function (gallery) {
    var blockId = gallery.id.replace('svd-vg-', '');
    var modal = document.getElementById('svd-vm-' + blockId);
    if (!modal) return;

    var modalVideo = modal.querySelector('.svd-video-modal__video');
    var modalClose = modal.querySelector('.svd-video-modal__close');
    var modalBackdrop = modal.querySelector('.svd-video-modal__backdrop');

    // Autoplay first video on scroll
    var firstItem = gallery.querySelector('.svd-video-gallery__item--first');
    if (firstItem) {
      var firstVideo = firstItem.querySelector('.svd-video-gallery__video');
      var firstOverlay = firstItem.querySelector('.svd-video-gallery__overlay');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && firstVideo.paused) {
            firstVideo.play().catch(function () {});
            if (firstOverlay) firstOverlay.style.display = 'none';
          }
        });
      }, { threshold: 0.5 });
      observer.observe(firstItem);
    }

    // Click-to-play + click-to-pause for all videos
    gallery.querySelectorAll('.svd-video-gallery__item').forEach(function (item) {
      var overlay = item.querySelector('.svd-video-gallery__overlay');
      var video = item.querySelector('.svd-video-gallery__video');
      if (!overlay || !video) return;

      // Overlay click: play and hide overlay
      overlay.addEventListener('click', function () {
        overlay.style.display = 'none';
        video.play().catch(function () {});
      });

      // Video click: pause and show overlay
      video.addEventListener('click', function () {
        if (!video.paused) {
          video.pause();
          overlay.style.display = 'flex';
        }
      });

      // After video ends: restore overlay
      video.addEventListener('ended', function () {
        overlay.style.display = 'flex';
      });
    });

    // Dots navigation (synlig på mobil, horisontell scroll)
    var items = Array.from(gallery.querySelectorAll('.svd-video-gallery__item'));
    var dotsContainer = gallery.parentElement.querySelector('.svd-video-gallery__dots');
    if (dotsContainer && items.length > 1) {
      items.forEach(function (_, i) {
        var li = document.createElement('li');
        li.className = 'dot' + (i === 0 ? ' is-selected' : '');
        li.addEventListener('click', function () {
          gallery.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
        });
        dotsContainer.appendChild(li);
      });
      var dots = Array.from(dotsContainer.querySelectorAll('.dot'));
      gallery.addEventListener('scroll', function () {
        var active = 0;
        var min = Infinity;
        items.forEach(function (item, i) {
          var dist = Math.abs(item.offsetLeft - gallery.scrollLeft);
          if (dist < min) { min = dist; active = i; }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-selected', i === active);
        });
      }, { passive: true });
    }

    // Expand button: open modal
    gallery.querySelectorAll('.svd-video-gallery__expand-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var item = btn.closest('.svd-video-gallery__item');
        var video = item.querySelector('.svd-video-gallery__video');
        video.pause();

        modalVideo.innerHTML = '';
        video.querySelectorAll('source').forEach(function (src) {
          modalVideo.appendChild(src.cloneNode(true));
        });
        modalVideo.load();
        modalVideo.play().catch(function () {});

        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeydown);
      });
    });

    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
    }

    function closeModal() {
      modalVideo.pause();
      modalVideo.currentTime = 0;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
    }

    modalClose.addEventListener('click', closeModal);
    modalBackdrop.addEventListener('click', closeModal);
  });
})();
